class viewController {
    constructor($translate, $http, $sce, $stateParams, authService, myBookingService, sharedService) {
        'ngInject';
        this.name = 'view';
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$sce = $sce;
        this.$http = $http;
        this.myBookingService = myBookingService;
        this.authService = authService;
        this.IS_MOBILE = sharedService.IS_MOBILE;
        this.showIframe = false;
        this.showPdfNotFoundError = false;
        this.lastPdfVoucherUrl = null;
        this.successCallback = this.successCallback.bind(this)
        this.errorCallback = this.errorCallback.bind(this)
    }

    getLastPdfVoucherUrl() {
        return this.myBookingService.getLastPdfVoucherUrl(
            this.$stateParams.bookingReference,
            this.authService.getAccessToken()
        );
    }

    successCallback() {
        this.lastPdfVoucherUrl = this.$sce.trustAsResourceUrl(this.getLastPdfVoucherUrl());
        this.showIframe = true;
    }
    errorCallback() {
        this.showIframe = false;
        this.showPdfNotFoundError = true;
    }

    $onInit() {
        this.$http({
            method: 'HEAD',
            url: this.getLastPdfVoucherUrl()
        }).then(this.successCallback, this.errorCallback);

        this.translations = this.$translate.instant([
            "content_title_view"
        ]);

        this.booking.translations.mainTitleKey = this.translations.content_title_view;
    }
}

export default viewController;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/view/view.controller.js